import Vue from 'vue'
import VueRouter from 'vue-router'
import PopupNew from '../views/PopupNew.vue'
import Kid from '../views/Kid.vue'
import Login from "../views/Login";
import PageNotFound from "../views/PageNotFound";
import PremiumNoLogin from "../views/PremiumNoLogin";
import LandingFlow from "../views/LandingFlow";
import Welcome from "../views/Welcome";
import AddDeviceView from "../views/AddDeviceView";
import Premium from "@/components/Premium";
// eslint-disable-next-line no-unused-vars
import firebase from "firebase/app";
import Dashboard from "@/views/Dashboard";
import FreeDashboard from "@/views/FreeDashboard";
import Profile from "@/views/Profile";
import Device from "@/views/Device";
import Locked from "@/views/Locked";
import Request from "@/views/Request";
import Removed from "@/views/Removed";
import Help from "@/views/Help";
import Recover from "@/views/Recover";
import store from '../store/store'
import Account from "@/views/Account";
import NewProfile from "@/views/NewProfile";
import FreeVersionDesktopPlug from "@/views/FreeVersionDesktopPlug";
import GetTrialPremiumPage from "@/views/GetTrialPremiumPage";
// eslint-disable-next-line no-unused-vars
import {db} from "@/fb/firebase";
import FreeDashboardContent from "@/components/FreeDashboardContent";
import PopupProfileSettings from "@/views/PopupProfileSettings";
import {reportEvent} from "@/helpers/utils";

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '/freeDashboard',
    component: FreeDashboard,
    children: [
      {
        path: '/profile/:profileId',
        component: Profile,
      },
      {
        path: '/',
        component: FreeDashboardContent,
      }
    ]
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/device/:deviceID',
    component: Device,
  },
  {
    path: '/popup',
    component: PopupNew
  },
  {
    path: '/kid',
    component: Kid
  },
  {
    path: '/locked',
    component: Locked
  },
  {
    path: '/request',
    component: Request
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/premium',
    component: PremiumNoLogin
  },
  {
    path: '/premiumfeatures',
    component: Premium
  },
  {
    path: '/landing-flow',
    component: LandingFlow
  },
  {
    path: '/removed',
    component: Removed
  },
  {
    path: '/account',
    component: Account
  },
  {
    path: '/newprofile',
    component: NewProfile
  },
  {
    path: '/plug',
    component: FreeVersionDesktopPlug
  },
  {
    path: '/gettrial',
    component: GetTrialPremiumPage
  },
  {
    path: '/',
    component: Welcome
  },
  {
    path: '/help',
    component: Help
  },
  {
    path: '/recover',
    component: Recover
  },
  {
    path: '/profileSettings',
    component: PopupProfileSettings
  },
  {
    path: '/addDevice',
    component: AddDeviceView
  },
  {
    path: "*",
    component: PageNotFound
  }
];

const router = new VueRouter({
  routes
})


/*
function routerGuard(to, from, next) {
  const user = store.state.user;
  const isRemote = store.state.isRemote;
  const isPremium = store.state.accountData.isPremium;
  if (user.uid && !isPremium && isRemote) {
    next(false)
  } else {
    next();
  }
}
*/

router.beforeEach((to, from, next) => {
  console.log(to, from);
  const { query } = to;

  reportEvent('pageLoad', {
    pageRoute: to.fullPath,
  })

  if ('enterTestmode' in query) {
    if (query.enterTestmode ==='1') {
      localStorage.setItem('stripeTest', '1');
      alert('test payment mode activate');
    } else {
      localStorage.removeItem('stripeTest');
      alert('test payment mode inactive')
    }
  }

  if (query.extID) {
    localStorage.setItem('extID', query.extID);
  }

  if (query.deviceid) {
    localStorage.setItem('deviceID', query.deviceid);
    store.commit('setDeviceID', query.deviceid);
    store.commit('setIsRemote', false);
    next();
    return;
  }

  if (query.testNavigation || window.Android) { // for mobile testing
    next();
    return;
  }

  if (to.path === '/locked' && from.path === '/kid' && !query.force) {
   /* db.ref('users/' + store.state.user.uid + '/settings/devices/' + store.state.currentDeviceID).update({
      currentProfileID: null,
    })*/
    return;
  }

  /*const isRemote = localStorage.getItem('isRemote');
  const remoteConditionRedirect = isRemote && JSON.parse(isRemote) && to.path !== '/login';
  const user = firebase.auth().currentUser
  if (remoteConditionRedirect) {
    if (user && user.email) {
      firebase.database().ref('users/' + user.uid + '/settings/isPremium/').get().then((snapshot) => {
        if (snapshot.exists() && snapshot.val()) {
          next()
        } else {
          next('/login')
        }
      })
    } else {
      next('/login')
    }
  } else {
      next()
  }*/
  next()
})

export default router
